<ion-content [fullscreen]="true">
  <div class="ds-onboarding" *ngIf="!bigTotalumLoader">
    <div class="ds-onboarding-totalumlogo-container">
      <div class="ds-onboarding-totalumlogo">
        <img src="assets/totalum-logo-recortado.png" alt="Totalum logo">
      </div>
    </div>
    
    <div class="ds-onboarding-content">

      <div style="width: 100%;">
        <div class="ds-onboarding-texts">
          <h1 class="ds-onboarding-texts-title">{{onboardingFlow[currentIndex]?.title}}</h1>
          <p class="ds-onboarding-texts-subtitle">{{onboardingFlow[currentIndex]?.subtitle}}</p>
        </div>

        <ng-container *ngIf="onboardingFlow[currentIndex]?.display === 'solo-input'">
          <app-solo-input #soloInputComponent [onboardingFlowStep]="onboardingFlow[currentIndex]" (onChangeValues)="onChangeValues($event)"></app-solo-input>
        </ng-container>

        <ng-container *ngIf="onboardingFlow[currentIndex]?.display === 'double-input'">
          <app-double-input [onboardingFlowStep]="onboardingFlow[currentIndex]" (onChangeValues)="onChangeValues($event)"></app-double-input>
        </ng-container>
  
        <div class="ds-onboarding-button">
          <button class="ds-button-primary" [disabled]="loading || invalidForm" (click)="onSubmitStep()">
            <ng-container *ngIf="loading">
              <ion-spinner name="crescent"></ion-spinner>
              {{ 'SENDING' | translate }}
            </ng-container>
    
            <ng-container *ngIf="!loading && !onboardingFlow[currentIndex]?.validation?.totalumName">
              {{ 'CONTINUE' | translate }}
            </ng-container>

            <ng-container *ngIf="!loading && onboardingFlow[currentIndex]?.validation?.totalumName">
              {{ 'CREATE_TOTALUM' | translate }}
            </ng-container>
          </button>


        </div>
      </div>

      <div class="ds-onboarding-footer">
        <div>
          On enter you accept the <a href="https://www.totalum.app/terms-and-conditions">Terms and Conditions</a> | <a href="https://www.totalum.app/politica-de-privacidad">Privacy Policy</a>
        </div>
        <div>
          © {{currentYear}} Totalum
        </div>
      </div>
    </div>
  </div>

  <div class="ds-onboarding" *ngIf="bigTotalumLoader">
    <!--<button (click)="progressBar = progressBar + 20">Subir</button>-->
    <div class="ds-onboarding-content">
 
      <div class="ds-bigtotalumloader">
        <div class="ds-bigtotalumloader-totalumlogo" [ngClass]="{'ds-bigtotalumloader-totalumlogo-big': progressFinished}">
          <img src="assets/totalum-logo-recortado.png" alt="Totalum logo">
        </div>

        <div class="ds-bigtotalumloader-progressbar" *ngIf="!progressFinished">

          <div class="ds-bigtotalumloader-progressbar-bar" [ngStyle]="{'width': progressBar + '%'}"></div>

        </div>

        
      </div>

      <div class="ds-bigtotalumloader-text">
        {{progressText}}
      </div>

      <div></div> <!-- no delete: this div is for flex purposes -->

      <div class="ds-onboarding-footer">
        <div>
          <a href="">Terms and Conditions</a> | <a href="">Privacy Policy</a>
        </div>
        <div>
          © {{currentYear}} Totalum 
        </div>
      </div>

    </div>
    
  </div>
</ion-content>
